import React, { useState, useEffect } from "react"

import { Link } from "gatsby"
import MetaButton from "@components/MetaButton"

import { useSiteMetadata, useURLforArray } from "@hooks/siteURLs"
import LanguageSwitchWithHover from "@components/LanguageSwitchWithHover"
import useCustomTranslation from "@hooks/useCustomTranslation"

import OpenMobileMenu from "@images/open_mobile_menu.png"
import OpenMobileMenuDark from "@images/open_mobile_menu_dark.png"
import CloseMobileMenu from "@images/close_mobile_menu.png"
import CloseMobileMenuDark from "@images/close_mobile_menu_dark.png"

import { useRedirectToPro, useRedirectToPartnerUI } from "@hooks/siteURLs"

export const BrandLogo = ({ logoUrl, logoSrc, isDesktop = false }) => (
  <Link
    to={logoUrl}
    className={`
    p-6 
    mr-2
    
    ${isDesktop && "pl-0 pr-3 py-5"}
     `}
  >
    <img src={logoSrc} alt="Metaloop Logo" />
  </Link>
)

export const BrandLogoWithoutLink = ({ logoSrc, isDesktop = false }) => (
  <div
    className={`p-6 mr-2
	    ${isDesktop && "pl-0 pr-3 py-5"}`}
  >
    <img src={logoSrc} alt="Metaloop Logo" />
  </div>
)

const SingleMenuOption = ({ url, textColor, title, whatMenuShow }) => {
  const { t } = useCustomTranslation()
  return (
    <Link
      to={url}
      className={`
        block no-underline ${textColor} px-6 py-3 uppercase text-xs font-semibold font-inter transition-colors hover:text-mgreen tracking-[0.16px]  
        
        ${whatMenuShow !== "mobile" && "md:text-tiny"} 
        ${
          whatMenuShow === "desktop" &&
          "desk:py-5 desk:px-3 fhd:text-base desk:text-[16px]"
        } 
        `}
    >
      <span>{t(title)}</span>
    </Link>
  )
}

const ComplexMenuOption = ({
  textColor,
  title,
  subMenuBackgroundColor,
  subMenuTextColor,
  elements,
  arrowIcon,
  whatMenuShow,
}) => {
  const isDesktop = whatMenuShow === "desktop"
  const [isOpened, setOpened] = useState(isDesktop)
  const { t } = useCustomTranslation()

  const toggleState = () => {
    // Keep it open always in desktop resolution
    setOpened(!isOpened)
  }

  const onMouseLeave = () => {
    if (isDesktop) setOpened(true)
  }

  //Every time isMobile and isTablet changes we need to update the state
  useEffect(() => {
    setOpened(isDesktop)
  }, [whatMenuShow])

  const metadata = useSiteMetadata("url")
  const allLinks = elements.map(e => e.url)

  const allUrls = useURLforArray(allLinks)

  var newElements = elements.map(e => {
    return {
      ...e,
      url: allUrls[e.url],
    }
  })

  return (
    <div className="group relative">
      <div
        className="flex justify-between"
        onClick={toggleState}
        onMouseLeave={onMouseLeave}
      >
        <span
          className={`block no-underline ${textColor} px-6 ${
            whatMenuShow !== "desktop" && isOpened ? "pt-3 pb-1" : "py-3"
          } 
          uppercase text-xs font-semibold font-inter cursor-default hover:text-mgreen tracking-[0.16px] 

          ${whatMenuShow !== "mobile" && "md:text-tiny"}
          ${
            whatMenuShow === "desktop" &&
            "desk:px-3 desk:py-5 fhd:text-base desk:text-[16px]"
          }


       `}
        >
          {t(title)}
        </span>
        <img
          src={arrowIcon}
          alt="arrow down"
          className={` ${whatMenuShow === "desktop" && "desk:hidden"} mr-6 ${
            isOpened ? "rotate-180" : ""
          }`}
        />
      </div>
      <div
        className={`group-hover:flex ${isOpened ? "block" : "!hidden"} ${
          whatMenuShow === "desktop" &&
          "desk:hidden desk:absolute desk:left-[-50px] desk:w-[273px]"
        }`}
      >
        <div
          className={`
            
            flex flex-col ml-6 py-3 pt-0 ${subMenuBackgroundColor}  w-full
            
            
            ${
              whatMenuShow === "desktop" &&
              "desk:mr-[14px] desk:ml-[28px] desk:px-8 desk:py-5 desk:mt-[15px]"
            }
      `}
        >
          <div
            className={`
                hidden absolute ${subMenuBackgroundColor} rotate-45 w-3 h-3 top-[9px]
                
                   ${whatMenuShow === "desktop" && "desk:block "}
                `}
          ></div>
          {(newElements || []).map((e, i) => (
            <Link
              to={e.url}
              className="py-1 desk:py-2"
              key={`complex-menu-item-${i}`}
            >
              <span
                className={`${subMenuTextColor} text-sm font-inter tracking-[0.16px]
                
                  ${
                    whatMenuShow === "desktop" &&
                    "desk:text-base desk:uppercase desk:font-semibold "
                  }
                 `}
              >
                {t(e.title)}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export const MenuLinkItem = ({
  title,
  url,
  textColor,
  textActiveColor,
  elements,
  subMenuBackgroundColor,
  subMenuTextColor,
  arrowIcon,
  whatMenuShow,
}) => {
  const metadata = useSiteMetadata(url)

  return (
    <li
      className={`
    basis-full width-full 
    
    ${whatMenuShow === "desktop" && "desk:basis-auto desk:w-auto"} `}
    >
      {url ? (
        <SingleMenuOption
          url={
            typeof url === "string" && url.startsWith("http")
              ? url
              : metadata.url
          }
          textColor={textColor}
          title={title}
          whatMenuShow={whatMenuShow}
        />
      ) : (
        <ComplexMenuOption
          textColor={textColor}
          title={title}
          subMenuBackgroundColor={subMenuBackgroundColor}
          subMenuTextColor={subMenuTextColor}
          elements={elements}
          arrowIcon={arrowIcon}
          whatMenuShow={whatMenuShow}
        />
      )}
    </li>
  )
}

export const MenuOptions = ({
  textColor,
  textActiveColor,
  bgColor,
  isCollapse,
  theme,
  menus,
  smBoxShadowT,
  subMenuBackgroundColor,
  subMenuTextColor,
  arrowIcon,

  whatMenuShow,
  getStartedEvent = {
    id: "Pro Form All",

    triggers: "GetStarted",
    source: "Homepage",
  },
  forceToShowTabletMenu,
}) => {
  const { t } = useCustomTranslation()
  const urlPro = useRedirectToPro()
  const partnerUIUrl = useRedirectToPartnerUI()

  if (!Array.isArray(menus)) {
    return null
  }

  return (
    <div
      className={`
        basis-full 
        w-full 
        items-center 
        grow
        fixed
        z-10
        top-0 
        left-0 
        right-0 
        bottom-0
        h-screen
        pt-16
        ${bgColor}
        ${isCollapse ? "hidden" : "block"}

        ${whatMenuShow !== "mobile" && "md:w-[375px] md:left-auto md:right-0"}
        ${
          whatMenuShow === "desktop" &&
          "desk:w-auto desk:flex desk:basis-auto  desk:static z-auto  desk:left-auto desk:right-auto desk:bottom-auto desk:top-auto  desk:h-auto desk:pt-0  "
        }
        
       
        
        `}
    >
      <ul
        className={`
            flex flex-row flex-wrap pl-0 m-0 mt-9 list-none 
            

            ${whatMenuShow === "desktop" && "desk:m-0 desk:ml-auto"}
            `}
      >
        {menus.map(menu => (
          <MenuLinkItem
            key={menu.title}
            textColor={textColor}
            textActiveColor={textActiveColor}
            subMenuBackgroundColor={subMenuBackgroundColor}
            subMenuTextColor={subMenuTextColor}
            arrowIcon={arrowIcon}
            whatMenuShow={whatMenuShow}
            {...menu}
          />
        ))}
        <li
          className={`
            basis-full width-full 

            ${whatMenuShow === "desktop" && "desk:basis-auto desk:w-auto "}
            `}
        >
          <LanguageSwitchWithHover
            textColor={textColor}
            textActiveColor={textActiveColor}
            subMenuBackgroundColor={subMenuBackgroundColor}
            subMenuTextColor={subMenuTextColor}
            isMobile={whatMenuShow === "mobile"}
            arrowIcon={arrowIcon}
            forceToShowTabletMenu={forceToShowTabletMenu}
          />
        </li>
        {whatMenuShow !== "desktop" && (
          <li style={{ display: "block" }}>
            <div className="ml-6 ">
              <MetaButton
                as="link"
                url={urlPro}
                useNavigate={false}
                theme={theme}
                className="!text-[14px] !p-3"
                dataEvent={getStartedEvent}
                inverted
              >
                {t("About_Button1")}
              </MetaButton>
            </div>
            <div className="ml-6 mt-1 ">
              <MetaButton
                as="link"
                url={partnerUIUrl}
                theme={theme}
                className="!text-[14px] !p-3"
              >
                {t("Button_Log_in")}
              </MetaButton>
            </div>
          </li>
        )}
      </ul>
      {whatMenuShow === "desktop" && (
        <ul
          className={`flex flex-row flex-wrap p-0 m-0 list-none items-center absolute desk:static bottom-0 w-full desk:w-auto justify-between desk:justify-start ${smBoxShadowT} desk:shadow-none`}
        >
          <li className="basis-auto w-auto md:basis-auto md:w-auto px-6 py-4 md:pl-3 md:pr-0 md:py-5">
            <div className="-mt-3">
              <MetaButton
                as="link"
                url={urlPro}
                useNavigate={false}
                theme={theme}
                inverted
                className="desk:!px-5 desk:!py-[13px] !text-[14px] desk:!text-[16px] font-semibold "
                dataEvent={getStartedEvent}
              >
                {t("About_Button1")}
              </MetaButton>
            </div>
          </li>
          <li className="basis-auto w-auto desk:basis-auto desk:w-auto px-6 py-4 desk:pl-3 desk:pr-0 desk:py-5">
            <div className="-mt-3">
              <MetaButton
                as="link"
                url={partnerUIUrl}
                theme={theme}
                className="desk:!px-5 desk:!py-[11px] !text-[14px] desk:!text-[16px] font-semibold "
              >
                {t("Button_Log_in")}
              </MetaButton>
            </div>
          </li>
        </ul>
      )}
    </div>
  )
}

export const OpenCloseMobileMenu = ({
  textColor,
  isCollapse,
  onCollapse,
  isDesktop = false,
}) => {
  const openSrc =
    textColor === "text-white" ? OpenMobileMenu : OpenMobileMenuDark
  const closeSrc =
    textColor === "text-white" ? CloseMobileMenu : CloseMobileMenuDark
  return (
    <button
      className={`p-6 pt-[23px] border-0 block 
        ${textColor} 
        ${isDesktop && "desk:hidden"} `}
      type="button"
      data-bs-toggle="collapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
      onClick={onCollapse}
    >
      {isCollapse ? (
        <img src={openSrc} alt="Open mobile menu" />
      ) : (
        <img src={closeSrc} alt="Close mobile menu" />
      )}
    </button>
  )
}
